'use strict'

var stickySidebar = stickySidebar || {}
var $ = jQuery

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
stickySidebar.init = function () {
  stickySidebar.start()

  Drupal.behaviors.start = {
    attach: function (context, settings) {
      stickySidebar.start()
    },
  }
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(stickySidebar.init)

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
stickySidebar.start = function () {

  // console.info('stickySidebar');

  $('.sidebar').stickySidebar({
    topSpacing: 0,
    bottomSpacing: 0,
    containerSelector: false,
    innerWrapperSelector: '.sidebar__inner',
    scrollContainer: true,
    resizeSensor: true,
    stickyClass: 'is-affixed',
    minWidth: 0
  });

}
